import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import CharacterEditor from "@/pages/CharacterEditor";
import AuthCallback from "@/pages/AuthCallback";
import SharedCharacter from "@/pages/SharedCharacter";
import Chronicles from "@/pages/Chronicles";
import Chronicle from "@/pages/Chronicle";
import ChronicleJoin from "@/pages/ChronicleJoin";
import { Toaster } from "sonner";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth return via hash fragment BEFORE routes render.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/character/:id" element={<CharacterEditor />} />
      <Route path="/chronicles" element={<Chronicles />} />
      <Route path="/chronicle/join/:code" element={<ChronicleJoin />} />
      <Route path="/chronicle/:id" element={<Chronicle />} />
      <Route path="/chronicle/:chronId/character/:id" element={<CharacterEditor />} />
      <Route path="/share/:shareId" element={<SharedCharacter />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              className: "font-mono uppercase tracking-widest text-xs",
              style: {
                background: "#111116",
                border: "2px solid #ffe600",
                color: "#f8f8fc",
                borderRadius: 0,
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
